<template>
  <div>
    <template v-for="(custom_field, index) in form.custom_fields">
      <form-field-custom-field
          v-model="custom_field.value"
          :custom-field-id="custom_field.id"
          :validation-error="(validationErrors[`custom_fields.${index}.value`]) ? validationErrors[`custom_fields.${index}.value`][0] : ''"
          :key="index"
      ></form-field-custom-field>
    </template>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";
  import {MODELS} from "../services/models";
  import FormFieldCustomField from "../components/form/FormFieldCustomField";
  import {ENUMS} from "../services/enums";

  export default {
    name: "ContactCustomFieldsForm",
    components: {FormFieldCustomField},
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = this.$utils.clone(this.formData);
      this.setCustomFields();
    },
    computed: {
      allCustomFields() {
        return this.$store.getters.customFields(ENUMS.CustomFieldableTypeEnum.ContactType.value, this.form.contact_type_id);
      },
    },
    methods: {
      setCustomFields() {
        this.allCustomFields.forEach(customField => {
          const contactTypeField = this.form.custom_fields.find(field => field.id === customField.id);

          if (! contactTypeField) {
            this.form.custom_fields.push({
              class_name: MODELS.CustomFieldJson.class_name,
              id: customField.id,
              value: customField.default_value,
            });
          }
        });
      },
      update() {
        return this.$api.contactContactType.update(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Custom Details were updated',
              type: 'is-success'
            });

            return res;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
